import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const Versions = (props: {
  versionOpenState: boolean;
  // setVersionOpenState: boolean;
  setVersionOpenState: (_0: boolean) => void;
}) => {
  const { versionOpenState, setVersionOpenState } = props;
  const [submitState, setSubmitState] = React.useState(false);

  const onSubmit = (data: any) => {
    setVersionOpenState(false);

    // setTimeout(() => {
    //   setFormOpenState(false);
    //   setSubmitState(false)
    // }, 4000);
  };

  const handleClose = () => {
    setVersionOpenState(false);
  };

  return (
    <div>
      <Dialog open={versionOpenState} onClose={handleClose}>
        {submitState === false ? <DialogTitle>Versions</DialogTitle> : ""}
        <DialogContent>
          {submitState === false ? (
            <>
              <DialogContentText>
                Since we have initial version, you can download it from direct
                link
              </DialogContentText>
              <Box mt={3}></Box>
            </>
          ) : (
            <Grid sx={{ width: "100%", textAlign: "center" }}>
              <Box>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <LoadingButton
                    // loading={isLeading}

                    variant="text"
                    sx={{
                      mt: 3,
                      mb: 2,
                      width: "100px",
                      height: "100px",
                    }}
                  >
                    <CheckCircleOutlineIcon
                      sx={{ color: "#5ACE65", fontSize: "60px" }}
                    />
                  </LoadingButton>
                </Box>

                <Typography
                  component="h5"
                  variant="h5"
                  sx={{ fontSize: "30px" }}
                >
                  {"Thank you for contacting"}
                </Typography>
                <Typography
                  variant="body2"
                  mb={2}
                  mt={1}
                  sx={{ color: "gray", fontSize: "16px" }}
                >
                  {"We'll review your message and get back to you shortly."}
                </Typography>
              </Box>
            </Grid>
          )}
        </DialogContent>
        
      </Dialog>
    </div>
  );
};

export default Versions;
